<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    isAllStoresAvailable?: boolean
    displayStoreName?: boolean
    storesList: { id: number; name: string }[]
  }>(),
  {
    isAllStoresAvailable: true,
    displayStoreName: true
  }
)
const emit = defineEmits(['updateDropdown'])

const { selectStore, selectedStore } = useStore()
const { stores: storesItem } = useLocalStorage()
const route = useRoute()
const { t } = useI18n()

const storesOptions = ref<{ value: string; label: string }[]>([])
const displayDropdown = ref(true)
const singleStoreId = ref<number | null>(null)

const dropdownWithoutStoreRoutes = ['LoyaltyEdit']
const isRouteWithoutStoreDropdown = computed(() => dropdownWithoutStoreRoutes.includes(route.name as string))

const selectedStoreString = computed({
  get: () => (selectedStore.value != null ? String(selectedStore.value) : ''),
  set: (v: string) => updateStore(Number(v))
})

const singleStoreString = computed(() => (singleStoreId.value != null ? String(singleStoreId.value) : ''))

const updateStore = (storeId: number) => {
  selectStore(storeId)
  emit('updateDropdown', storeId)
}

const fetchData = () => {
  const stores = props.storesList?.length ? props.storesList : storesItem.value

  if (stores.length === 1 && !isRouteWithoutStoreDropdown.value) {
    displayDropdown.value = false
    singleStoreId.value = stores[0].id
  }

  storesOptions.value.push(
    ...stores.map((store) => ({
      value: String(store.id),
      label: store.name
    }))
  )
}

onMounted(() => {
  if (isRouteWithoutStoreDropdown.value) {
    storesOptions.value.push({
      value: '0',
      label: t('ui.dropdownStore.allMyStores')
    })
  } else {
    storesOptions.value.push({
      value: '0',
      label: props.isAllStoresAvailable ? t('ui.dropdownStore.allStores') : t('ui.dropdownStore.selectStores')
    })
  }

  fetchData()
})
</script>

<template>
  <div class="z-20">
    <ComboboxSelect
      v-if="displayDropdown"
      v-model="selectedStoreString"
      :options="storesOptions"
      :search-placeholder="t('global.multiselect.default.filterPlaceholder')"
      :empty-message="t('global.multiselect.default.searchingMessage')"
    />

    <ComboboxSelect v-else-if="displayStoreName" :model-value="singleStoreString" :options="storesOptions" disabled />
  </div>
</template>
